module.exports = __webpack_public_path__ + "static/media/defaultProfileAvatar.9613379f.svg";